import { useSelector } from 'Modules/core/redux';

import { Download } from './types';


const DOWNLOADS_KEY = 'downloads';

export const useDownloads = (path: any): Download => {
    const result = useSelector(`${DOWNLOADS_KEY}.${path}`, [path]);
    return result;
};
